import React, { useEffect } from 'react';

export const UserHome = () => {
    useEffect(() => {
        document.title = "User Dashboard";
    }, []);

    return (
        <h1 className="p-2">
            Welcome to OTT!
        </h1>
    );
}